<template>
	<div class="page-container">
		<HeaderLayout :pagecode="pagecode" @eventProblemCode="updateProblemCode"></HeaderLayout>
		<div class="listBox">
			<ProblemList :code="code"></ProblemList>	
		</div>
		<FooterLayout></FooterLayout>
	</div>
</template>

<script>
import ProblemList from '@/components/Problem/List'
		
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'


export default {
	name: 'Main',
	components: {
		  HeaderLayout,
		  FooterLayout,
		  ProblemList
  	},
	data() {

		  return {
			pagecode:'main',
			code:'ai',
			
		  }
	},
	created() {
		
		
	},
    methods: {
		updateProblemCode(code) {
			this.code = code;
		}
	},
	mounted() {
		//this.updatePage();	
	},
	updated() {
		//this.updatePage();	
	}
}
</script>

<style lang="scss" scoped>
.searchBox {
	width:100%;
	background:#fff;
	display:none;
	z-index:1000;
	height:0;
}
.page-container      {
     width:100%;
	 min-height:calc(100vh);
}
</style>